import React, { Component } from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBModal,
  MDBModalBody,
} from "mdbreact";
import axios from "axios";
import ConfigData from "../Components/config";
import AppDataTable from "../Components/AppDataTable";

export default class Showcertificatehistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array_ShowReportPetition: [],
      modalcreate: false,
    };
    this.handleTHCreateFile = this.handleTHCreateFile.bind(this);
    this.handleENCreateFile = this.handleENCreateFile.bind(this);
    this.OpenRpt = this.OpenRpt.bind(this);
  }
  OpenRpt(event) {
    var splitvalue = event.target.value.split(",");
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/PrintPetition/" + splitvalue[0])
      .then(() => {
        if (splitvalue[1] === "1") {
          window.open(
            "https://e-certificate.kpru.ac.th/downloads_file/" + splitvalue[0] + "-thai.pdf",
            "_blank"
          );
        } else {
          window.open(
            "https://e-certificate.kpru.ac.th/downloads_file/" + splitvalue[0] + "-en.pdf",
            "_blank"
          );
        }
        axios
          .get(
            ConfigData.SERVER_URL +
              "FrontEnd_Tabian/petition/ShowReportPetition/" +
              localStorage.getItem("id")
          )
          .then((ShowReportPetition) => {
            if (ShowReportPetition.data.length !== 0) {
              this.setState({ array_ShowReportPetition: ShowReportPetition.data });
            }
          });
      });
  }
  componentDidMount() {
    if (!localStorage.getItem("token")) {
      window.location.href = "/rubrongkpru";
    }
    axios
      .get(ConfigData.SERVER_URL + "FrontEnd_Tabian/payment/ShowBillPetitionPaymenthistory/")
      .then((ShowReportPetition) => {
        if (ShowReportPetition.data.length !== 0) {
          var i = 0;
          const dd = ShowReportPetition.data;
          while (i < ShowReportPetition.data.length) {
            ShowReportPetition.data[i]["Index"] = i + 1;
            if (ShowReportPetition.data[i]["STATUS"] === "0") {
              ShowReportPetition.data[i]["Statusfill"] = (
                <button className="btn btn-danger btn-sm">
                  <MDBIcon icon="ban" /> ไม่อนุญาตการขอใบรับรอง
                </button>
              );
            } else if (ShowReportPetition.data[i]["STATUS"] === "4") {
              ShowReportPetition.data[i]["Statusfill"] = (
                <span>
                  <button className="btn btn-success btn-sm">
                    <MDBIcon icon="check-circle" /> ใบรับรองเสร็จสมบูรณ์{" "}
                  </button>
                  {ShowReportPetition.data[i]["STATUSCREATETHAI"] ? (
                    <>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={this.handleTHCreateFile}
                        value={ShowReportPetition.data[i]["ID_NUMBER"]}
                      >
                        <MDBIcon icon="file-signature" /> สร้างใบรับรองภาษาไทยใหม่{" "}
                      </button>
                      <button
                        className="btn btn-dark btn-sm"
                        value={dd[i]["ID_NUMBER"] + "," + 1}
                        onClick={this.OpenRpt}
                        hidden={dd[i]["NUM_RUBRONGTH"] > "0" ? false : true}
                      >
                        <i class="fas fa-download"></i> ดาวน์โหลดเอกสารทางการศึกษา{" "}
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {ShowReportPetition.data[i]["STATUSCREATEENG"] ? (
                    <>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={this.handleENCreateFile}
                        value={ShowReportPetition.data[i]["ID_NUMBER"]}
                      >
                        <MDBIcon icon="file-signature" /> สร้างใบรับรองภาษาอังกฤษใหม่{" "}
                      </button>
                      <button
                        className="btn btn-dark btn-sm"
                        value={dd[i]["ID_NUMBER"] + "," + 2}
                        onClick={this.OpenRpt}
                        hidden={dd[i]["NUM_RUBRONGEN"] > "0" ? false : true}
                      >
                        <i class="fas fa-download"></i> ดาวน์โหลดเอกสารทางการศึกษาภาษาอังกฤษ{" "}
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              );
            }
            i++;
          }
          this.setState({
            array_ShowReportPetition: {
              columns: [
                { label: "#", field: "Index" },
                { label: "วันที่ร้องขอ", field: "DATE_INSERT" },
                { label: "รหัสนักศึกษา", field: "OLDID" },
                { label: "ชื่อ-นามสกุล", field: "NAME" },
                { label: "ขอใบรับรองเรื่อง", field: "TYPEPITITION_NAME" },
                { label: "ภาษาไทย", field: "NUM_RUBRONGTH" },
                { label: "ภาษาอังกฤษ", field: "NUM_RUBRONGEN" },
                { label: "สถานะ", field: "Statusfill" },
              ],
              rows: ShowReportPetition.data,
            },
          });
        }
      });
  }

  handleTHCreateFile(event) {
    this.setState({ modalcreate: true });
    axios
      .get(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/petition/CreateRubrong/" + event.target.value + "/1"
      )
      .then((CreateRubrong) => {
        if (CreateRubrong.data === 1) {
          this.setState({ modalcreate: false });
        }
      });
  }

  handleENCreateFile(event) {
    this.setState({ modalcreate: true });
    axios
      .get(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/petition/CreateRubrong/" + event.target.value + "/2"
      )
      .then((CreateRubrong) => {
        if (CreateRubrong.data === 1) {
          this.setState({ modalcreate: false });
        }
      });
  }

  render() {
    return (
      <>
        <span className="white-text mt-3" style={{ fontSize: "22px" }}>
          สถานะการขอใบรับรอง
        </span>
        <span className="white-text mt-3" style={{ fontSize: "16px" }}>
          {" "}
          มหาวิทยาลัยราชภัฏกำแพงเพชร
        </span>

        <MDBRow>
          <MDBCol lg="12" md="12" sm="12">
            <MDBCard className="mt-3">
              <MDBCardBody>
                <MDBCardTitle className="h5">สถานะการขอใบรับรอง</MDBCardTitle>
                <MDBCardText>
                  <AppDataTable data={this.state.array_ShowReportPetition} />
                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>

        <MDBModal isOpen={this.state.modalcreate} size="md" centered>
          <MDBModalBody className="text-align">
            <div
              class="spinner-border text-success"
              style={{ width: "36px", height: "36px" }}
              role="status"
            ></div>
            <br />
            <span style={{ fontSize: "18px" }}>ระบบกำลังดำเนินการสร้างเอกสารทางการศึกษา&nbsp;</span>
          </MDBModalBody>
        </MDBModal>
      </>
    );
  }
}
